import { render, staticRenderFns } from "./PropertyAlerts.vue?vue&type=template&id=42f1a396&scoped=true&"
import script from "./PropertyAlerts.vue?vue&type=script&lang=js&"
export * from "./PropertyAlerts.vue?vue&type=script&lang=js&"
import style0 from "./PropertyAlerts.vue?vue&type=style&index=0&id=42f1a396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f1a396",
  null
  
)

export default component.exports